export const ADD_NOTA_CLINICA_TO_ARRAY = "ADD_NOTA_CLINICA_TO_ARRAY";
export const REMOVE_NOTA_CLINICA = "REMOVE_NOTA_CLINICA";
export const FETCH_NOTAS_CLINICAS_REQUEST = "FETCH_NOTAS_CLINICAS_REQUEST";
export const FETCH_NOTAS_CLINICAS_SUCCESS = "FETCH_NOTAS_CLINICAS_SUCCESS";
export const FETCH_NOTAS_CLINICAS_FAILURE = "FETCH_NOTAS_CLINICAS_FAILURE";
